import * as Ably from "ably";

let ablyClient = null;
const activeChannels = {};

export const getAblyClient = () => {
  if (!ablyClient) {
    ablyClient = new Ably.Realtime({
      key: "_5T0zQ.XOp1Fg:li54clPnpFyM2nF1nzt2zJC_ioB2vXBdA_5M2xP_U_0", 
      autoConnect: true,
      recover: true,
      disconnectedRetryTimeout: 5000,
      suspendedRetryTimeout: 10000,
    });
  }
  return ablyClient;
};

export const subscribeToMatchChannel = async (matchId, callback) => {
  const channelName = `match-${matchId}`;
  const client = getAblyClient();

  if (!activeChannels[channelName]) {
    const channel = client.channels.get(channelName);

    await channel.attach();

    const handler = (msg) => callback(msg);
    channel.subscribe(handler);

    activeChannels[channelName] = { channel, handler };
  }
};

export const unsubscribeFromMatchChannel = (matchId) => {
  const channelName = `match-${matchId}`;
  const entry = activeChannels[channelName];

  if (entry) {
    const { channel, handler } = entry;
    channel.unsubscribe(handler);
    channel.detach();
    delete activeChannels[channelName];
  }
};

export const closeAbly = () => {
  if (ablyClient) {
    ablyClient.close();
    ablyClient = null;
    Object.keys(activeChannels).forEach((key) => delete activeChannels[key]);
  }
};
